import axios from "axios";
import qs from "qs";

import { getStoreForJson,setStore } from './mUtils';

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.BASE_API;
axios.defaults.withCredentials = true;
//http response 拦截器ss
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(error)
    return Promise.reject(error);
  }
);
// 请求拦截器
axios.interceptors.request.use(config => {
  if (config.url.includes('/html5')) {
    let token_boject = getStoreForJson('h5token')
    let timestamp = Date.parse(new Date());
    if(token_boject&&token_boject.expiration>timestamp){
      config.headers['Authorization'] = 'html5 ' + token_boject.token
    }else{
      window.location.replace('/login');
      return
    }
  }
  // Spin.show()
  // 在发送请求之前做些什么
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

export default async (url = '', data = {}, method = 'fetch', authUrl = 'h5') => {
  if (method == 'fetch') {
    return await fetch(authUrl + url, data);
  } else if (method == 'post') {
    return await post(authUrl + url, data);
  } else if (method == 'posts') {
    return await posts(authUrl + url, data);
  } else if (method == 'patch') {
    return await patch(authUrl + url, data);
  } else if (method == 'put') {
    return await post(authUrl + url, data);
  }
}
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求表单类型
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 封装post请求josn类型
 * @param url
 * @param data
 * @returns {Promise}
 */
export function posts (url, data) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/http.js